import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from "@angular/core";
import { LiveInputModel } from "./liveInput.component/liveInput.model";
import { LiveInputEvent } from "./liveInput.component/liveInput.component";
import { UI } from "../../services/ui.service";
import { GraphicsInfo } from "../../domain/graphics-info";
import { Socket } from "../../infrastructure/socket.service";
import { UserService } from "../../domain/user-service";
import { ShowRepository } from "../../domain/show-repository";
import {
  Channel,
  ChannelInfo,
  EAutoExtendLiveShowBehaviour,
} from "../../domain/channel";
import { WebRTCPreview } from "../../domain/web-r-t-c-preview";
import { LiveFeedPreview } from "../../domain/live-feed-preview";
import { CalendarService } from "../../domain/calendar-service";
import moment from "moment";
import { ToastrService } from "ngx-toastr";
import {
  isBroadcastPresetShowLike,
  LiveShow,
  MediaShow,
  Show,
} from "../../domain/show";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable, Subject, Subscription } from "rxjs";
import { debounceTime, throttleTime } from "rxjs/operators";
import { LiveFeedRepository } from "../../domain/live-feed-repository";
import { ConversionUtils } from "../../domain/conversion-utils";
import { ICommonUtilInterface } from "../../domain/common/common-util.interface";
import { ChannelRepository } from "../../domain/channel-repository";
import { User } from "../../domain/user";
import { IEvrideoDialogService } from "../../domain/common/i-evrideo-dialog-service";
import { LiveOtherUserEnteredComponent } from "./live-other-user-entered/live-other-user-entered.component";

@Component({
  selector: "live",
  templateUrl: "./live.component.html",
  styleUrls: ["./live.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LiveComponent implements OnInit, OnDestroy {
  targetChannelTimezone: string;
  nextShowStartTime: moment.Moment;
  nextShowEndTime: moment.Moment;
  breakDuration: string;
  breakDurationEndTime: moment.Moment;
  breakStartTime: moment.Moment;
  firstBreakShowStartTime: moment.Moment;
  @ViewChild("liveFeedPreviewContainer")
  liveFeedPreviewContainer: ElementRef<HTMLDivElement>;
  @ViewChild("programPreviewContainer")
  programPreviewContainer: ElementRef<HTMLDivElement>;
  @ViewChild("liveFeedPreview")
  liveFeedPreview: ElementRef<HTMLVideoElement>;
  @ViewChild("programPreview")
  programPreview: ElementRef<HTMLVideoElement>;
  private RTL_CHAR_REGEX: RegExp = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
  mamCollapsedSubscription: any;
  updateFirstBreakShowStartTimeAfterSkipToOperation: boolean = false;
  constructor(
    private ui: UI,
    private _userService: UserService,
    private _showsRepository: ShowRepository,
    private _calendarService: CalendarService,
    private _toastr: ToastrService,
    private _liveFeedRepository: LiveFeedRepository,
    private _socketService: Socket,
    private router: Router,
    private _commonUtils: ICommonUtilInterface,
    private _cdf: ChangeDetectorRef,
    private _dialogService: IEvrideoDialogService,
    private viewContainerRef: ViewContainerRef,
    private _route: ActivatedRoute,
  ) {}

  isEditorOpen = false;

  panels = [
    new PanelModel("Switcher Panel 001", true),
    new PanelModel("Switcher Panel 2"),
  ];
  selectedPanelIndex = 0;
  currentChannel: Channel;
  currentUser: User;
  // isliveBroadcastActive = false;
  transitions = [
    {
      type: "Fade In",
    },
    {
      type: "Fade Out",
    },
    {
      type: "Dissolved",
    },
  ];

  previewContent: LiveInputModel = null;
  previewIndex: number = null;

  liveContent: LiveInputModel = null;
  liveIndex: number = null;
  isLiveFeedVideoLoaded = false;
  isProgramVideoLoaded = false;

  /* Right sidebar settings */
  sidebarTitle = "Edit Preview Graphics";
  currentChannelPreview: WebRTCPreview;
  currentLiveFeedPreview: WebRTCPreview;
  _lastPreviewFeedId = "";
  nextShow: Show;
  nextLive: LiveShow;
  /** Next schedule slot that is either a live feed or a broadcast preset (for Live panel UI). */
  nextLiveOrBroadcastSlot: Show | null = null;
  _lastNextShowId: string;
  _lastNextLiveId: string;
  _lastCurrentShowId: string;
  currentShow: Show;
  lastShowsResult: Show[];
  previousResultData = new PreviousResultData(null, null, null);
  _previousResultNextShow: Show;
  currentShowElaplsedTimeMs?: number;
  currentShowRemainingTimeMs?: number;
  currentShowStartTime: moment.Moment;
  currentShowEndTime: moment.Moment;
  timeTillNextItemMs?: number;
  timeTillNextLiveMs?: number;
  listenToChannelBroadcastingInterval;
  pingLiveFeedPreviewInterval;
  socketServiceOnHubDisconnectedSubscription;
  private _socketServiceOnHubReconnectedSubscription: Subscription;
  private _schedulerUpdatedDebounceTimeout: any;
  isNextShowPrerollReadyToSkip = false;
  isNextLivePrerollReadyToSkip = false;
  duringSkipToOperation = false;
  public get duringUpdatePreroll(): boolean {
    return (
      this.isNextShowPrerollReadyToSkip === false ||
      this.isNextLivePrerollReadyToSkip === false
    );
  }
  public get duringUpdatePrerollOrSkip(): boolean {
    return this.duringUpdatePreroll || this.duringSkipToOperation;
  }
  lastSentPrerollItems = {};
  scheduleUpdateListenerHandler: any;
  /*nextItemChangedSubject = new Subject<void>();
  nextLiveChangedSubject = new Subject<void>();*/
  updatePrerollSubject = new Subject<boolean>();
  private _updatePrerollSubscriptionInitialized = false;
  showLiveLockedButton: boolean = false;
  private _clientId: string;
  private autoExtendLiveShowBehaviour: EAutoExtendLiveShowBehaviour;
  private uiUpdateInterval: any;
  ngOnInit() {
    console.log(`live.component->ngOnInit`);
    this._clientId =
      this._commonUtils.generateGuid() +
      "_livePage" +
      "";
      //window.prompt("Enter client ID suffix:");
    console.log("live.component->ngOnInit->_clientId=", this._clientId);

    this.uiUpdateInterval = setInterval(() => {
      this._cdf.markForCheck();
    }, 1000);
    this._initUpdatePrerollObjectListeners();

    this._userService.getCurrentChannel(true).then(async (channel) => {
      const currentUser = this._userService.getCurrentUser();
      await this._socketService.enteredLivePageEventHandler(
        channel.id,
        currentUser.username,
        this._clientId,
        this._otherUserEnteredLivePage.bind(this),
      );
      this.currentChannel = channel;
      this.currentUser = this._userService.getCurrentUser();
      this.targetChannelTimezone = this._userService.getTimezoneValueById(
        this.currentChannel.timezoneId,
      );
      const channelInfo = await this._userService.getCurrentChannelInfo(false);
      this.autoExtendLiveShowBehaviour =
        channelInfo.autoExtendLiveShowBehaviour;
      this.showLiveLockedButton =
        channelInfo.autoExtendLiveShowBehaviour ===
        EAutoExtendLiveShowBehaviour.Empty;
      console.log("live.component->ngOnInit", this.currentChannel);
      this.notifyAboutChannelStatus();
      this.scheduleUpdateListenerHandler =
        this._onSchedulerUpdatedEventHandler.bind(this);
      this._socketServiceOnHubReconnectedSubscription =
        this._socketService.onHubReconnected.subscribe(() => {
          this.internalDestroy();
          this._refreshPage();
        });
      this.socketServiceOnHubDisconnectedSubscription =
        this._socketService.onHubDisconnected.subscribe(
          this._onHubDisconnected.bind(this),
        );
      const schedulerUpdatesSubscription = async () =>
        this._socketService.startListeningForSchedulerUpdates(
          channel.id,
          this.scheduleUpdateListenerHandler,
        );
      this._socketService.onHubReconnected.subscribe(async () => {
        this._socketService.stopListeningForSchedulerUpdates(
          this.scheduleUpdateListenerHandler,
        );
        await schedulerUpdatesSubscription();
        this.refreshCalendarService();
      });
      return schedulerUpdatesSubscription()
        .then(() => {
          return this.refreshCalendarService().then(() => {
            this.listenToChannelBroadcasting();
            this.getLiveFeedPreview();
          });
        })
        .then(() => {
          //return Promise.resolve();
          return this._socketService.startListeningForLiveBroadcastingUpdates(
            channel.id,
            this._onLiveBroadcastingUpdatedEventHandler.bind(this),
          );
        })
        .then(() => {
          return this._socketService.startListeningForChannelStatusUpdates(
            channel.id,
            this._onChannelStatusUpdatedEventHandler.bind(this),
          );
        })
        .then(() => {
          return this._socketService.startListeningForChannelAutopilotUpdates(
            channel.id,
            this._onChannelAutopilotUpdatedEventHandler.bind(this),
          );
        });
    });

    if (this.panels[0]) {
      this.selectedPanelIndex = 0;
    }

    this.ui.EVENTS.LiveStatusDidChange.subscribe((newStatus) => {
      if (!this.isEditorOpen && !newStatus) {
        return;
      }

      this.openEditor.call(this);
    });
    this.mamCollapsedSubscription = this.ui.EVENTS.MamCollapsed.subscribe(
      (value) => {
        setTimeout(() => {
          if (this.liveFeedPreview?.nativeElement) {
            this.adjustAspectRatio(
              this.liveFeedPreviewContainer.nativeElement,
              this.liveFeedPreview.nativeElement,
            );
          }
          if (this.programPreview?.nativeElement) {
            this.adjustAspectRatio(
              this.programPreviewContainer.nativeElement,
              this.programPreview.nativeElement,
            );
          }
        }, 1);
      },
    );
  }
  private _refreshPage() {
    console.log("live.component->_refreshPage->", this.router.url);
    window.location.reload();
  }

  private async _otherUserEnteredLivePage(
    channelId: number,
    username: string,
    time: Date,
  ): Promise<void> {
    this._dialogService
      .openDialog(this.viewContainerRef, {
        type: "warning",
        title: "Live Page Disconnected",
        hideCloseButton: true,
        hideIcon: true,
        backDropOpacity: 0.9,
        confirmButtonText: "CLOSE",
        content: LiveOtherUserEnteredComponent,
        contentContext: {
          otherUsernameConnected: username,
        },
        timeout: null as any,
      })
      .then((result) => {
        this.router.navigateByUrl(`/channels`);
      });
    setTimeout(() => {
      this.internalDestroy();
    }, 2000);
    if (this.liveFeedPreview && this.liveFeedPreview.nativeElement) {
      this.liveFeedPreview.nativeElement.pause();
    }
    if (this.programPreview && this.programPreview.nativeElement) {
      this.programPreview.nativeElement.pause();
    }
  }

  private _initUpdatePrerollObjectListeners() {
    if (!this._updatePrerollSubscriptionInitialized) {
      this._updatePrerollSubscriptionInitialized = true;
      this.updatePrerollSubject.pipe(debounceTime(5500)).subscribe({
        next: (force: boolean) => {
          return this.refreshCalendarService().then(() => {
            return this._updatePreroll(force);
          });
        },
        error: (e) => {
          console.log(
            "live.component->_initUpdatePrerollObjectListeners->updatePrerollSubject->error",
            e,
          );
        },
      });
    }
  }
  listenToChannelBroadcasting() {
    this.initLiveBroadcastState();
    this.listenToChannelBroadcastingInterval = setInterval(() => {
      // console.log('live.component->listenToChannelBroadcasting');
      this.initLiveBroadcastState();

      if (this.currentChannel.isLiveLocked === false) {
        this.getLiveFeedPreview();
      }
    }, 100);
  }
  private _onHubDisconnected() {
    console.log(`live.component->_onHubDisconnected-> Reloading the page`);
    this._reloadCurrentRoute();
  }
  private _reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }
  private _onSchedulerUpdatedEventHandler(
    channelId,
    startTimeUtc,
    endTimeUtc,
  ): void {
    this.debounce(async () => {
      await this.refreshCalendarService();
      this.initLiveBroadcastState();
      this.updatePrerollSubject.next(true);
      console.log(
        "live.component->this._socketService.startListeningForSchedulerUpdates->onSchedulerUpdatedEventHandler->",
        channelId,
        startTimeUtc,
        endTimeUtc,
        this._calendarService.currentShow,
      );
      
    }, 500);
  }
  private _onLiveBroadcastingUpdatedEventHandler(
    channelId: number,
  ): Promise<void> {
    return this._userService.getCurrentChannel(true).then((updatedChannel) => {
      console.log(
        `live.component->>onLiveBroadcastingUpdatedEventHandler->this.currentChannel updated, is live locked ${this.currentChannel.isLiveLocked}`,
        updatedChannel,
      );
      this.currentChannel = updatedChannel;
      this.notifyAboutLiveBroadcastingStatus();

      return this.refreshCalendarService().then(() => {
        console.log(
          "live.component->>onLiveBroadcastingUpdatedEventHandler->",
          updatedChannel,
        );
      });
    });
  }
  private _onChannelAutopilotUpdatedEventHandler(
    channelId: number,
    autopilotRuleId: string,
  ): Promise<void> {
    return this.refreshCalendarService().then(() => {
      console.log(
        "live.component->this._socketService.startListeningForChannelAutopilotUpdates->_onChannelAutopilotUpdatedEventHandler->",
        channelId,
        autopilotRuleId,
      );
      this._initUpdatePrerollObjectListeners();
      this.updatePrerollSubject.next(this.currentChannel.isActive);
    });
  }
  private _onChannelStatusUpdatedEventHandler(
    channelId: number,
  ): Promise<void> {
    return this._userService
      .getCurrentChannel(true)
      .then(async (updatedChannel) => {
        console.log(
          `live.component->_onChannelStatusUpdatedEventHandler->this.currentChannel updated, is live locked ${this.currentChannel.isLiveLocked}`,
          updatedChannel,
        );
        this.currentChannel = updatedChannel;
        const channelInfo =
          await this._userService.getCurrentChannelInfo(false);

        this.autoExtendLiveShowBehaviour =
          channelInfo.autoExtendLiveShowBehaviour;
        this.showLiveLockedButton =
          this.autoExtendLiveShowBehaviour ===
          EAutoExtendLiveShowBehaviour.Empty;
        this.notifyAboutChannelStatus();

        return this.refreshCalendarService().then(() => {
          console.log(
            "live.component->>_onChannelStatusUpdatedEventHandler->",
            updatedChannel,
          );
        });
      });
  }

  adjustAspectRatio(colElement: HTMLElement, element: HTMLVideoElement) {
    var width = element.clientWidth + "px";
    colElement.style.width = width;
    if (!this.currentLiveFeedPreview) {
      this.liveFeedPreviewContainer.nativeElement.style.width = width;
    }
    if (!this.currentChannelPreview) {
      this.programPreviewContainer.nativeElement.style.width = width;
    }
  }

  refreshCalendarService(): Promise<void> {
    this._calendarService.clearCache();
    const currentTime = this._calendarService.CurrentTime.clone();
    const relevantPrerollShowDurationMs =
      this.currentUser.channelPlaylistDurationMs -
      this.currentUser.channelPlaylistRequestAheadMs;
    const livebroadcastRangeTime = currentTime.add(
      relevantPrerollShowDurationMs,
      "milliseconds",
    );

    return this._userService.getCurrentChannel(false).then(async (channel) => {
      this.currentChannel = channel;

      console.log(
        `live.component->refreshCalendarService-> returned channel ${channel.isLiveLocked}, this.currentChannel ${this.currentChannel.isLiveLocked}`,
      );
      this.previousResultData = new PreviousResultData(
        this.nextShow?.clone(),
        this.nextLive?.clone() as LiveShow,
        null,
      );
      if (this.lastShowsResult) {
        this.previousResultData.showsList = this.lastShowsResult.map((s) =>
          s.clone(),
        );
      }
      /*if (
        false &&
        this.currentChannel.isLiveLocked &&
        this.autoExtendLiveShowBehaviour === EAutoExtendLiveShowBehaviour.Empty
      ) {
        return this._showsRepository
          .getLiveBroadcastingState(this.currentChannel.id)

          .then((shows) => {
            this.lastShowsResult = [...shows];
            console.log(
              "live.component->refreshCalendarService->this.lastShowsResult updated with live broadcasting state",
            );
          });
      } else {*/
        return this._calendarService
          .getByDates(
            this.currentChannel.id,
            this._calendarService.CurrentTime,
            livebroadcastRangeTime,
            false,
            null,
            true,
            true,
          )
          .then((shows) => {
            this.lastShowsResult = [...shows];
            console.log(
              "live.component->refreshCalendarService->this.lastShowsResult updated with regular state",
            );
            return this._calendarService.updateShows();
          })
          .then(() => {
            // console.log('live.component->refreshCalendarService', this._calendarService.currentShow);
          });
      //}
    });
  }

  initLiveBroadcastState() {
    // counters
    this.currentShowElaplsedTimeMs = null;
    this.currentShowRemainingTimeMs = null;
    this.timeTillNextItemMs = null;
    this.timeTillNextLiveMs = null;

    const dateTimeNow = moment();

    if (this.lastShowsResult && this.duringSkipToOperation === false) {
      this.currentShow = null;
      this.nextShow = null;
      this.nextLive = null;
      this.nextLiveOrBroadcastSlot = null;
      if (
        false &&
        this.currentChannel.isLiveLocked &&
        this.autoExtendLiveShowBehaviour == EAutoExtendLiveShowBehaviour.Empty
      ) {
        this.currentShow = this.lastShowsResult[0];
        this.nextShow = this.lastShowsResult[1];
        this.nextLive = this.lastShowsResult[2] as LiveShow;
      } else {
        this.currentShow = this.lastShowsResult.find(
          (s) =>
            s.endTime.isSameOrAfter(dateTimeNow) &&
            s.startTime.isSameOrBefore(dateTimeNow),
        );
        this.nextShow = this.lastShowsResult.find(
          (s) =>
            (!this.currentShow || s.id !== this.currentShow.id) &&
            s.startTime.isSameOrAfter(dateTimeNow),
        );
        this.nextLive = this.lastShowsResult.find(
          (s) =>
            (!this.currentShow || s.id !== this.currentShow.id) &&
            s instanceof LiveShow &&
            s.startTime.isSameOrAfter(dateTimeNow),
        ) as LiveShow;

        this.nextLiveOrBroadcastSlot =
          this.lastShowsResult.find(
            (s) =>
              (!this.currentShow || s.id !== this.currentShow.id) &&
              (s instanceof LiveShow || isBroadcastPresetShowLike(s)) &&
              s.startTime.isSameOrAfter(dateTimeNow),
          ) ?? null;
      }
    }
    this.adjustTimers(dateTimeNow);

    let shouldUpdatePreroll = false;
    const nextLiveChanged =
      (this._lastNextLiveId === null && this.nextLive !== null) ||
      (this.nextLive === null && this._lastNextLiveId !== null) ||
      (this.nextLive && this.nextLive.id !== this._lastNextLiveId);

    const nextShowChanged =
      (this._lastNextShowId === null && this.nextShow !== null) ||
      (this.nextShow === null && this._lastNextShowId !== null) ||
      (this.nextShow && this.nextShow.id !== this._lastNextShowId);

    if (nextLiveChanged) {
      console.log(
        "live.component->initLiveBroadcastState->nextLive changed to ",
        this.nextLive,
      );
      this.getLiveFeedPreview();
      shouldUpdatePreroll = true;
      // Reset break start time when nextLive changes
      this.breakStartTime = null;
    }

    if (nextShowChanged) {
      console.log(
        "live.component->initLiveBroadcastState->nextShow changed to ",
        this.nextShow,
      );
      shouldUpdatePreroll = true;
      // Reset break start time when nextShow changes
      this.breakStartTime = null;
    }

    this._lastNextLiveId = null;
    if (this.nextLive) {
      this._lastNextLiveId = this.nextLive.id;
    }
    this._lastNextShowId = null;
    if (this.nextShow) {
      this._lastNextShowId = this.nextShow.id;
    }
    // Track currentShow changes to detect break entry
    const currentShowId = this.currentShow?.id;
    if (currentShowId !== this._lastCurrentShowId) {
      this._lastCurrentShowId = currentShowId;
    }
    let forceUpdatingPreroll = false;
    if (
      shouldUpdatePreroll === false &&
      this.previousResultData.checkIfShouldUpdatePreroll(this.lastShowsResult)
    ) {
      console.log(
        `live.component->initLiveBroadcastState->this.previousResultData.checkIfShouldUpdatePreroll is true`,
      );
      shouldUpdatePreroll = true;
      forceUpdatingPreroll = true;
    } else {
      //console.log(`live.component->this.previousResultData.checkIfShouldUpdatePreroll is false`);
    }

    this.previousResultData = new PreviousResultData(
      this.nextShow?.clone(),
      this.nextLive?.clone() as LiveShow,
      this.lastShowsResult?.map((s) => s.clone()),
    );

    if (shouldUpdatePreroll) {
      this._initUpdatePrerollObjectListeners();
      this.updatePrerollSubject.next(forceUpdatingPreroll);
    }

    /*console.log(
      "live.component->initLiveBroadcastState",
      this.currentShow,
      this.nextShow,
      this.nextLive,
    );*/
  }

  adjustTimers(dateTimeNow: moment.Moment) {
    if (this.currentShow) {
      this.currentShowStartTime = this.currentShow.startTime
        .clone()
        .tz(this.targetChannelTimezone);
      this.currentShowEndTime = this.currentShow.endTime
        .clone()
        .tz(this.targetChannelTimezone);
      this.currentShowElaplsedTimeMs = dateTimeNow
        .clone()
        .diff(this.currentShow.startTime.clone(), "milliseconds");
      this.currentShowRemainingTimeMs = this.currentShow.endTime
        .clone()
        .diff(dateTimeNow.clone(), "milliseconds");
    }
    if (this.nextLive) {
      this.timeTillNextLiveMs = this.nextLive.startTime
        .clone()
        .subtract(this.nextLive.latencyMs, "milliseconds")
        .diff(dateTimeNow.clone(), "milliseconds");
    } else {
      this.nextLive = null;
    }
    if (this.nextShow) {
      this.timeTillNextItemMs = this.nextShow.startTime
        .clone()
        .diff(dateTimeNow.clone(), "milliseconds");
      this.nextShowStartTime = this.nextShow.startTime
        .clone()
        .tz(this.targetChannelTimezone);
      this.nextShowEndTime = this.nextShow.endTime
        .clone()
        .tz(this.targetChannelTimezone);
      this.setBreakDuration(dateTimeNow);
    } else {
      this.nextShow = null;
    }
    if (this.currentShowElaplsedTimeMs < 0) {
      this.currentShowElaplsedTimeMs = 0;
    }
    if (this.currentShowRemainingTimeMs < 0) {
      this.currentShowRemainingTimeMs = 0;
    }
    if (this.timeTillNextItemMs < 0) {
      this.timeTillNextItemMs = 0;
    }
    if (this.timeTillNextLiveMs < 0) {
      this.timeTillNextLiveMs = 0;
    }
    if (
      this.updateFirstBreakShowStartTimeAfterSkipToOperation ||
      (this.currentShow &&
        this.currentShow instanceof LiveShow &&
        this.nextShow &&
        !(this.nextShow instanceof LiveShow))
    ) {
      {
        if (this.updateFirstBreakShowStartTimeAfterSkipToOperation) {
          this.firstBreakShowStartTime = this.currentShow.startTime
            .clone()
            .tz(this.targetChannelTimezone);
          this.updateFirstBreakShowStartTimeAfterSkipToOperation = false;
        } else {
          this.firstBreakShowStartTime = this.nextShow.startTime
            .clone()
            .tz(this.targetChannelTimezone);
        }
      }
    }
  }

  setBreakDuration(dateTimeNow: moment.Moment) {
    let breakUntilNextLiveDuration = 0;
    if (this.nextLive && this.nextShow) {
      if (
        this.currentShow &&
        this.currentShow instanceof LiveShow &&
        this.nextShow instanceof LiveShow
      ) {
        // No break between live shows
        breakUntilNextLiveDuration = 0;
        this.breakStartTime = null;
      } else if (this.nextLive.id === this.nextShow.id) {
        // When nextLive is the same as nextShow, count down from now
        breakUntilNextLiveDuration = this.timeTillNextItemMs;
        this.breakStartTime = null;
      } else {
        // There's a break period with potentially multiple items between nextShow and nextLive
        const breakEndTime = this.nextLive.startTime.clone();

        // Detect if we're currently in the break period
        // We're in the break if currentShow is not a LiveShow (we're playing a break item)
        const isInBreak =
          this.currentShow && !(this.currentShow instanceof LiveShow);

        // Detect when we enter the break period
        // Break starts when we transition from a LiveShow to a non-LiveShow, or when we start the first break item
        const currentShowId = this.currentShow?.id;
        const lastShowWasLive =
          this._lastCurrentShowId &&
          this.lastShowsResult?.find(
            (s) => s.id === this._lastCurrentShowId,
          ) instanceof LiveShow;
        const justEnteredBreak =
          lastShowWasLive &&
          isInBreak &&
          this._lastCurrentShowId !== currentShowId;

        // Set break start time when we enter the break
        if (justEnteredBreak || (isInBreak && !this.breakStartTime)) {
          // Break starts when currentShow (the first break item) starts
          if (this.currentShow) {
            this.breakStartTime = this.currentShow.startTime.clone();
          }
        }

        // Reset break start time if we're no longer in the break
        if (!isInBreak) {
          this.breakStartTime = null;
        }

        // Calculate remaining time
        if (this.breakStartTime && isInBreak) {
          // We're in the break, count down remaining time until nextLive starts
          breakUntilNextLiveDuration = breakEndTime.diff(
            dateTimeNow,
            "milliseconds",
          );
        } else {
          // We're not in the break yet, show total break duration
          // Calculate from when nextShow starts (when break starts) to when nextLive starts
          const calculatedBreakStart = this.nextShow.startTime.clone();
          breakUntilNextLiveDuration = breakEndTime.diff(
            calculatedBreakStart,
            "milliseconds",
          );
        }
      }
    } else {
      // No break if no nextLive or nextShow
      this.breakStartTime = null;
    }

    const finalBreakDuration = Math.max(breakUntilNextLiveDuration, 0);
    this.breakDuration = this.formatDuration(finalBreakDuration, null);
    // Break ends when nextLive starts
    this.breakDurationEndTime = this.nextLive
      ? this.nextLive.startTime.clone().tz(this.targetChannelTimezone)
      : null;
  }

  getBreakStartTime(): string {
    if (this.firstBreakShowStartTime) {
      return this.firstBreakShowStartTime.format("HH:mm:ss");
    }
    if (this.nextShowStartTime) {
      return this.nextShowStartTime.format("HH:mm:ss");
    }
    return "00:00:00";
  }

  getLiveFeedPreviewTitle() {
    /*if (this.currentShow instanceof LiveShow) {
      return this.currentShow.name;
    } else*/
       if (this.nextLive) {
      return this.nextLive.name;
    }
    return "Live Feed";
  }

  isBroadcastPresetShow(show: Show | null | undefined): boolean {
    return isBroadcastPresetShowLike(show);
  }

  isLiveShowSlot(show: Show | null): show is LiveShow {
    return show instanceof LiveShow;
  }

  getNextLivePanelTitle(): string {
    const slot = this.nextLiveOrBroadcastSlot ?? this.nextLive ?? null;
    if (!slot) {
      return "No upcoming live";
    }
    const base = slot.name;
    return this.isBroadcastPresetShow(slot) ? base + " (broadcast)" : base;
  }

  getNextItemPanelTitle(): string {
    if (!this.nextShow) {
      return "No upcoming item";
    }
    const base = this.nextShow.name;
    return this.isBroadcastPresetShow(this.nextShow)
      ? base + " (broadcast)"
      : base;
  }
  getLiveFeedPreview() {
    let relevantLiveFeed: LiveShow = null;
    /*if (this.currentShow instanceof LiveShow) {
      relevantLiveFeed = this.currentShow as LiveShow;
    } else */
      if (this.nextLive) {
      relevantLiveFeed = this.nextLive;
    } else {
      this.currentLiveFeedPreview = null;
      this._lastPreviewFeedId = null;
      this.resetVideoLoadedState("liveFeed");
    }
    if (
      relevantLiveFeed &&
      relevantLiveFeed.feedId !== this._lastPreviewFeedId
    ) {
      const currentFeedId = relevantLiveFeed.feedId;
      this._lastPreviewFeedId = currentFeedId;
      this.resetVideoLoadedState("liveFeed");
      this._socketService
        .createLiveFeedPreview(currentFeedId)
        .then((preview) => {
          const availabilityZoneUrls = Object.keys(preview.availabilityZoneUrls)
            .map((k) => preview.availabilityZoneUrls[k].url)
            .flat();
          this.currentLiveFeedPreview = new WebRTCPreview(
            preview.clientId,
            preview.brodcasterId,
            availabilityZoneUrls,
          );

          clearInterval(this.pingLiveFeedPreviewInterval);
          this.pingLiveFeedPreviewInterval = setInterval(() => {
            this._liveFeedRepository.pingLiveFeedPreview(preview.id);
          }, 10000);
        });
    } else {
      // console.log('live.component->getLiveFeedPreview-> remove preview');
    }
  }

  isLockLiveButtonDisabled() {
    return (
      !this.currentChannel ||
      !this.currentShow ||
      !(this.currentShow instanceof LiveShow) ||
      !this.currentChannel.isActive
    );
  }
  getChannelPreview() {
    if (
      !!this.currentChannel &&
      this.currentChannel.isActive &&
      !this.currentChannelPreview
    ) {
      this.resetVideoLoadedState("program");
      this._socketService
        .createChannelWebRTCPreview(this.currentChannel)
        .then((preview: WebRTCPreview) => {
          this.currentChannelPreview = preview;
        });
    }
  }
  onRefreshChannelPreview() {
    this.resetVideoLoadedState("program");
    this.currentChannelPreview = null;
    this.getChannelPreview();
  }

  onRefreshLiveFeedPreview() {
    this.resetVideoLoadedState("liveFeed");
    this.currentLiveFeedPreview = null;
    this.getLiveFeedPreview();
  }

  private notifyAboutLiveBroadcastingStatus() {
    if (this.currentChannel.isLiveLocked) {
      this._toastr.success(`Live is locked`);
    } else {
      this._toastr.success(`Live is unlocked`);
    }
  }
  private notifyAboutChannelStatus() {
    if (this.currentChannel.isActive) {
      this._toastr.success(`Channel ${this.currentChannel.name} is active!`);
    } else {
      this._toastr.warning(
        `Channel ${this.currentChannel.name} is not active! Channel Preview is unavailable.`,
      );
    }
    this.onRefreshChannelPreview();
  }
  onOnewaySwitch() {
    /* validate preview index */
    if (this.previewIndex == null) {
      return;
    }

    this.liveContent = this.previewContent;
    this.liveIndex = this.previewIndex;

    this.markAsOffAllInputs(false);
    this.panels[this.selectedPanelIndex]["items"][
      this.previewIndex
    ].isPlayingLive = true;

    this.previewContent = null;
    this.previewIndex = null;

    this.markAsOffAllInputs(true);
  }

  openEditor() {
    this.isEditorOpen = !this.isEditorOpen;
  }

  markAsOffAllInputs(isPreview: boolean) {
    const key = isPreview ? "isPlayingPreview" : "isPlayingLive";

    this.panels[this.selectedPanelIndex]["items"].map((item) => {
      if (item != null) {
        item[key] = false;
      }
      return item;
    });
  }

  private _updatePreroll(force: boolean): Promise<void> {
    if (this.currentChannel.isActive === false) {
      return Promise.resolve();
    }

    this.isNextShowPrerollReadyToSkip = false;
    this.isNextLivePrerollReadyToSkip = false;
    this._cdf.detectChanges();
    const prerolShows = [];
    if (this.nextShow) {
      prerolShows.push(this.nextShow);
    }
    if (this.nextLive) {
      prerolShows.push(this.nextLive);
    }

    let currentShowId = null;
    if (this.currentShow) {
      currentShowId = this.currentShow.id;
    }
    const prerolShowIds = prerolShows.map((s) => s.id);
    if (
      force ||
      (prerolShows.length > 0 &&
        this.checkIfShouldUpdatePrerollItems(prerolShowIds))
    ) {
      console.log(
        `live.component->_updatePreroll->clientId=${this._clientId}->force=${force}->[${
          this.currentChannel.id
        }] ${this.currentChannel.name} is LiveLocked-> ${
          this.currentChannel.isLiveLocked
        }->items: ${prerolShows
          .map(
            (s) => `[${s.id}]${s.name}:${s.startTime.format("HH:mm:ss.SSS")}`,
          )
          .join(",")}`,
        [...this.lastShowsResult],
      );
      if (this._clientId.includes('_internalDestroyCall')){
        return Promise.resolve();
      }
      return this._showsRepository
        .updatePrerollMedia(
          this.currentChannel.id,
          prerolShowIds,
          currentShowId,
          this._clientId,
        )
        .then(() => {
          this.lastSentPrerollItems = Object.assign(
            {},
            ...prerolShowIds.map((x) => ({ [x]: true })),
          );
          this.isNextShowPrerollReadyToSkip = true;
          this.isNextLivePrerollReadyToSkip = true;
        })
        .catch((e) => {
          this._toastr.error(e.message);
        });
    } else {
      console.log(
        `live.component->_updatePreroll->channel  [${this.currentChannel.id}] ${this.currentChannel.name}-> force=${force}-> preroll items are the same as last sent. Nothing to update.`,
      );
      this.isNextShowPrerollReadyToSkip = true;
      this.isNextLivePrerollReadyToSkip = true;
      return Promise.resolve();
    }
  }
  formatDuration(durationMs: number, relatedShow: Show): string {
    const isNegative = durationMs < 0;
    let latencyMs = 0;
    if (relatedShow && relatedShow instanceof LiveShow) {
      latencyMs = (relatedShow as LiveShow).latencyMs;
    }
    const duration = moment.duration(durationMs - latencyMs, "milliseconds");

    if (duration.isValid()) {
      return `${isNegative ? "-" : ""}${Math.abs(duration.hours())
        .toString()
        .padStart(2, "0")}:${Math.abs(duration.minutes())
        .toString()
        .padStart(2, "0")}:${Math.abs(duration.seconds())
        .toString()
        .padStart(2, "0")}`;
    } else {
      return "00:00:00";
    }
  }

  ngOnDestroy(): void {
    this.internalDestroy();
  }
  internalDestroy(): void {
    this._clientId += "_internalDestroyCall";
    console.log("live.component->internalDestroy()");
    if (this._socketServiceOnHubReconnectedSubscription) {
      this._socketServiceOnHubReconnectedSubscription.unsubscribe();
    }
    clearInterval(this.uiUpdateInterval);
    this.currentChannelPreview = null;
    this.currentLiveFeedPreview = null;
    this._socketService.stopListeningForChannelStatusUpdates();
    this._socketService.stopListeningForLiveBroadcastingUpdates();
    this._socketService.stopListeningForSchedulerUpdates(
      this.scheduleUpdateListenerHandler,
    );
    this._socketService.stopListeningForChannelAutopilotUpdates();
    this._socketService.stopListeningForOtherUserEnteredLivePage(
      this._otherUserEnteredLivePage,
    );
    if (this.socketServiceOnHubDisconnectedSubscription) {
      this.socketServiceOnHubDisconnectedSubscription.unsubscribe();
    }
    if (this.mamCollapsedSubscription) {
      this.mamCollapsedSubscription.unsubscribe();
    }
    clearInterval(this.listenToChannelBroadcastingInterval);
    clearInterval(this.pingLiveFeedPreviewInterval);
    this._cdf.detectChanges();
  }
  onButtonMouseDown(event: MouseEvent): void {
    // Prevent drag behavior that can interfere with click events
    event.preventDefault();
  }

  async skipToClicked(
    skipButton: HTMLButtonElement,
    immediately: boolean,
    isLiveShow: boolean,
    nextShow: Show,
  ): Promise<void> {
    if (this.duringSkipToOperation) {
      return;
    }
    if (!nextShow) {
      this._toastr.error(`No upcoming show found!`);
      return;
    }
    if (isBroadcastPresetShowLike(nextShow)) {
      return;
    }
    this.duringSkipToOperation = true;
    let offsetMs = 0;
    if (immediately === false) {
      offsetMs = await this._getSkipLatencyMs(nextShow);
    }

    return new Promise<void>((resolve) => {
      if (this.checkIfCanPerformSkip(isLiveShow) === false) {
        this._toastr.error(
          `Skip operation is not available right now. Please wait and try again!`,
        );
        console.log(
          `live.component->skipToClicked-> isLiveShow=${isLiveShow}, isNextLivePrerollReadyToSkip=${this.isNextLivePrerollReadyToSkip}, isNextShowPrerollReadyToSkip=${this.isNextShowPrerollReadyToSkip}`,
        );
        this.duringSkipToOperation = false;
      } else if (this.checkIfSkipDelayOverlapNextShow(nextShow, offsetMs)) {
        this._toastr.error(`Skip delay exceeds remaining time, can't skip!`);
        console.log(
          `live.component->skipToClicked-> isLiveShow=${isLiveShow}, isNextLivePrerollReadyToSkip=${this.isNextLivePrerollReadyToSkip}, isNextShowPrerollReadyToSkip=${this.isNextShowPrerollReadyToSkip}`,
        );
        this.duringSkipToOperation = false;
      } else {
        this._toastr.info(`Skip operation is in progress...`);

        const currentState = {
          currentShow: this.currentShow?.clone(),
          nextShow: this.nextShow?.clone(),
          nextLive: this.nextLive?.clone(),
          lastShowsResult: this.lastShowsResult?.map((s) => s.clone()),
        };

        // Add gradient fill animation if offsetMs is not 0
        if (offsetMs > 0) {
          this._addGradientFillAnimation(offsetMs, skipButton);
        }

        setTimeout(() => {
          const nextShowIndex = this.lastShowsResult.findIndex(
            (s) => s.id === nextShow.id,
          );
          if (nextShowIndex !== -1) {
            this.currentShow = this.lastShowsResult[nextShowIndex];
            this.nextShow = this.lastShowsResult.find(
              (s) =>
                s.id !== this.currentShow.id &&
                s.startTime.isSameOrAfter(this.currentShow.endTime),
            );
            this.nextLive = this.lastShowsResult.find(
              (s) =>
                s.id !== this.currentShow.id &&
                s instanceof LiveShow &&
                s.startTime.isSameOrAfter(this.currentShow.endTime),
            ) as LiveShow;
            const now = moment.utc();
            const shift = now.diff(this.currentShow.startTime, "milliseconds");
            this.currentShow.startTime = now.clone();
            if (this.nextShow) {
              this.nextShow.startTime = this.nextShow.startTime
                .clone()
                .add(shift, "milliseconds");
            }
            if (this.nextLive) {
              this.nextLive.startTime = this.nextLive.startTime
                .clone()
                .add(shift, "milliseconds");
            }
            this.adjustTimers(now);
            this.lastShowsResult = null;
          }
        }, offsetMs + 500);
        setTimeout(async () => {
          console.log(
            `live.component->skipToClicked-> performing skip to operation, offsetMs=${offsetMs}`,
          );
          this._calendarService
            .skipCurrentShow(nextShow.id, this._clientId)
            .then(() => {
              //clear the cache of preroll items
              this.lastSentPrerollItems = {};
              this.duringSkipToOperation = false;
              this._toastr.success(`Skip operation completed successfully!`);
              this.updateFirstBreakShowStartTimeAfterSkipToOperation = true;
              resolve();
            })
            .catch((err) => {
              console.error(err);
              this.currentShow = currentState.currentShow;
              this.nextShow = currentState.nextShow;
              this.nextLive = currentState.nextLive as LiveShow;
              this.lastShowsResult = currentState.lastShowsResult;
              this.duringSkipToOperation = false;
              this.getLiveFeedPreview();
              this._toastr.error(`Skip operation failed. Please try again!`);
            })
            .finally(() => {
              // Remove gradient fill classes
              this._removeGradientFillAnimation(skipButton);
            });
        }, offsetMs);
      }
    });
  }
  private _addGradientFillAnimation(
    offsetMs: number,
    skipButton: HTMLButtonElement,
  ) {
    if (skipButton) {
      requestAnimationFrame(() => {
        console.log(
          `live->_removeGradientFillAnimation-> skipButton is not null, adding fill animation... skipButton element:`,
          skipButton,
        );
        skipButton.classList.add("gradient-fill-animation");
        setTimeout(() => {
          skipButton.classList.remove("gradient-fill-animation");
        }, offsetMs);
        skipButton.classList.add("gradient-fill");
        skipButton.style.setProperty("--fill-duration", `${offsetMs}ms`);

        void skipButton.offsetWidth;

        requestAnimationFrame(() => {
          skipButton.classList.add("filling");
        });
      });

      // Start the animation after a small delay to ensure the class is added
      /*requestAnimationFrame(() => {
        skipButton.classList.add("filling");
      });*/
    } else {
      console.error(`live->_addGradientFillAnimation-> skipButton is null`);
    }
  }
  private _removeGradientFillAnimation(skipButton: HTMLButtonElement) {
    if (skipButton) {
      requestAnimationFrame(() => {
        console.log(
          `live->_removeGradientFillAnimation-> skipButton is not null, removing fill animation...`,
        );
        skipButton.classList.remove("gradient-fill", "filling");
        skipButton.style.removeProperty("--fill-duration");
      });
    } else {
      console.error(`live->_removeGradientFillAnimation-> skipButton is null`);
    }
  }
  private async _getSkipLatencyMs(nextShow: Show): Promise<number> {
    let relevantLiveShow: LiveShow;
    if (this.currentShow instanceof LiveShow) {
      if (nextShow instanceof LiveShow) {
        relevantLiveShow = nextShow as LiveShow;
      } else {
        relevantLiveShow = this.currentShow as LiveShow;
      }
    } else {
      if (nextShow instanceof LiveShow) {
        relevantLiveShow = nextShow as LiveShow;
      } else {
        return 0;
      }
    }

    return relevantLiveShow.latencyMs;
  }
  checkIfCanPerformSkip(isLiveShow: boolean) {
    return (
      (this.currentChannel &&
        this.currentChannel.isActive &&
        isLiveShow &&
        this.isNextLivePrerollReadyToSkip) ||
      (!isLiveShow && this.isNextShowPrerollReadyToSkip)
    );
  }

  checkIfSkipDelayOverlapNextShow(nextShow: Show, offsetMs: number) {
    const dateTimeUtcNow = moment().utc();
    const additionalOffsetMs = 2000;
    return (
      nextShow &&
      offsetMs > 0 &&
      nextShow.startTime.valueOf() - (offsetMs + additionalOffsetMs) <
        dateTimeUtcNow.valueOf()
    );
  }

  private checkIfShouldUpdatePrerollItems(prerolShowIds: string[]): boolean {
    let result = false;

    prerolShowIds.forEach((showUid) => {
      if (!this.lastSentPrerollItems[showUid]) {
        result = true;
      }
    });

    return result;
  }
  private debounce(callback: () => void, delay: number) {
    clearTimeout(this._schedulerUpdatedDebounceTimeout);
    this._schedulerUpdatedDebounceTimeout = setTimeout(callback, delay);
  }
  isLeftOrRightDirection(text: string): string {
    return this.RTL_CHAR_REGEX.test(text) ? "rtl" : "ltr";
  }

  private resetVideoLoadedState(playerType: "liveFeed" | "program") {
    if (playerType === "liveFeed") {
      this.isLiveFeedVideoLoaded = false;
    } else {
      this.isProgramVideoLoaded = false;
    }
  }
}

class PanelModel {
  public items: any[] = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ];
  public isPlayingLive = false;
  public isPlayingPreview = false;

  constructor(
    public header: string,
    public selected: boolean = false,
  ) {}

  addInputAtIndex(input, index) {
    this.items[index] = input;
    return this;
  }
}

class PreviousResultData {
  constructor(
    public nextShow: Show,
    public nextLive: LiveShow,
    public showsList: Show[],
  ) {}
  public checkIfShouldUpdatePreroll(newShowsList: Show[]): boolean {

    let result = false;

    const possiblePrerollOffset = moment.duration(1, "minutes");

    if (this.showsList) {
      if (this.nextShow) {
        const prevNextShowDataToCompare = this._getShowsBetweenDates(
          this.showsList,
          this.nextShow.startTime,
          this.nextShow.startTime.clone().add(possiblePrerollOffset),
        );
        const newNextShowDataToCompare = this._getShowsBetweenDates(
          newShowsList,
          this.nextShow.startTime,
          this.nextShow.startTime.clone().add(possiblePrerollOffset),
        );
        if (
          this._compareShowList(
            prevNextShowDataToCompare,
            newNextShowDataToCompare,
          ) === false
        ) {
          result = true;
        }
      }
      if (result === false && this.nextLive) {
        const prevNextLiveDataToCompare = this._getShowsBetweenDates(
          this.showsList,
          this.nextLive.startTime,
          this.nextLive.startTime.clone().add(possiblePrerollOffset),
        );
        const newNextLiveDataToCompare = this._getShowsBetweenDates(
          newShowsList,
          this.nextLive.startTime,
          this.nextLive.startTime.clone().add(possiblePrerollOffset),
        );
        if (
          this._compareShowList(
            prevNextLiveDataToCompare,
            newNextLiveDataToCompare,
          ) === false
        ) {
          result = true;
        }
      }
    }

    return result;
  }

  private _getShowsBetweenDates(
    inputList: Show[],
    start: moment.Moment,
    end: moment.Moment,
  ): Show[] {
    return [
      ...inputList.filter(
        (s) =>
          s.startTime.isSameOrAfter(start) && s.startTime.isSameOrBefore(end),
      ),
    ];
  }

  private _compareShowList(firstList: Show[], secondList: Show[]): boolean {
    let result = true;
    if (firstList && secondList) {
      if (firstList.length !== secondList.length) {
        result = false;
      } else {
        for (let i = 0; i < firstList.length; i++) {
          const showFromFirstList = firstList[i];
          const showFromSecondList = secondList[i];

          if (
            showFromFirstList.id !== showFromSecondList.id ||
            // tslint:disable-next-line:max-line-length
            showFromFirstList.startTime.isSame(showFromSecondList.startTime) ===
              false ||
            showFromFirstList.endTime.isSame(showFromSecondList.endTime) ===
              false ||
            showFromFirstList.som.asMilliseconds() !==
              showFromSecondList.som.asMilliseconds()
          ) {
            result = false;
          }
        }
      }
    }
    return result;
  }
}
